import Bloc from './Bloc.js';
import Types from './Types.js';

export default class StatValue extends Bloc {

	constructor (src, ctx) {

		super("statvalue", src, ctx);
		this.f = (src, ins) => [src.getStatValue(ins[0]), src.getStatValue(ins[0]) !== undefined];
		this.types = [Types.string];
	}
}